import { jsx as e } from "react/jsx-runtime";
import { PureComponent as o } from "react";
import { ErrorBoundaryContext as s } from "./ErrorBoundary.context.mjs";
class p extends o {
  constructor(r) {
    super(r), this.handleRefresh = () => {
      this.setState({
        hasError: !1,
        error: null
      });
    }, this.state = {
      hasError: !1,
      error: null
    };
  }
  static getDerivedStateFromError(r) {
    return { hasError: !0, error: r };
  }
  componentDidCatch(r, t) {
    typeof this.props.onDidCatch == "function" && this.props.onDidCatch(r, t);
  }
  render() {
    if (this.state.hasError && this.state.error) {
      const r = {
        onRefresh: this.handleRefresh,
        state: this.state
      };
      return /* @__PURE__ */ e(s.Provider, { value: r, children: this.props.fallback });
    }
    return this.props.children;
  }
}
export {
  p as E
};
//# sourceMappingURL=ErrorBoundary-c3WQZT5n.js.map
